import {Component, Input, OnInit} from '@angular/core';
import {LoaderStageInterface} from '../loader-stage.interface';

@Component({
  selector: 'app-mpq3-dr-loader-stage',
  templateUrl: './mpq3-dr-loader-stage.component.html',
  styleUrls: ['./mpq3-dr-loader-stage.component.scss']
})
export class Mpq3DrLoaderStageComponent implements OnInit {
  @Input() stage: LoaderStageInterface;

  constructor() { }

  ngOnInit() {
  }

}
